import React from 'react';
import styled from "styled-components";
const Crumb = props => {
    return (React.createElement(CrumbButton, { isActive: props.isActive, href: props.url },
        React.createElement(CrumbWrapper, null, props.displayName)));
};
const CrumbButton = styled.a `
    display: inline-block;
    height: 18px;
    margin-top: 2px;
    text-decoration: none;
    font-family: ${props => props.theme.fonts.medium};
    font-size: 13px;
    color: ${props => props.isActive ? props.theme.colors.black : props.theme.colors.inactiveBreadcrumbText};
    background: none;
    border: 0;
    cursor: pointer;
`;
const CrumbWrapper = styled.div `
`;
export default Crumb;
//# sourceMappingURL=Crumb.js.map